import "./index.css";
import axios from "axios";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";

const PaymentLoading = () => {
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(window.location.search);
  const userIdFromUrl =
    searchParams.get("userId") ||
    searchParams.get("UserId") ||
    sessionStorage.getItem("userId") ||
    localStorage.getItem("userId");
  // console.log("USER ID. : ", userIdFromUrl);

  const clientUserId =
    sessionStorage.getItem("userIdbyClient") ||
    localStorage.getItem("userIdbyClient");

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const MAX_ATTEMPTS = 5;
    const POLL_INTERVAL = 2000;
    let attempts = 0;
    let timeoutId;

    const checkPaymentStatus = async () => {
      attempts += 1;
      try {
        const res = await axios.get(
          // http://localhost:1044/api/partner/v1/gadget/GetPaymentStatusByUserId
          `https://gadgetuatapi.acrossassist.in/api/partner/v1/gadget/GetPaymentStatusByUserId?UserId=${userIdFromUrl}`,
          { headers: { "Content-Type": "application/json" } },
        );

        const orderStatus = res?.data?.data?.order_status;
        // console.log("order Status ", orderStatus);
        if (orderStatus === "Success") {
          navigate("/payment-success");
          return;
        }

        if (attempts < MAX_ATTEMPTS) {
          timeoutId = setTimeout(checkPaymentStatus, POLL_INTERVAL);
        } else {
          toast.error(
            res?.data?.status_message || "Payment verification failed.",
            {
              toastId: "payment-failed",
            },
          );
          navigate("/payment-failure");
        }
      } catch {
        if (attempts < MAX_ATTEMPTS) {
          timeoutId = setTimeout(checkPaymentStatus, POLL_INTERVAL);
        } else {
          navigate("/payment-failure");
        }
      }
    };

    checkPaymentStatus();

    return () => clearTimeout(timeoutId);
  }, [userIdFromUrl, clientUserId, navigate]);

  return (
    <Container
      fluid
      className="d-flex vh-100 justify-content-center align-items-center bg-light"
    >
      <Row>
        <Col xs={12} className="text-center">
          <Spinner
            role="status"
            variant="primary"
            animation="border"
            style={{ width: "4rem", height: "4rem" }}
          />
          <h3 className="mt-4">Processing Your Payment...</h3>
          <p className="text-muted">Please do not refresh the page.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentLoading;
